import { LoanType } from "@/modules/loan/common/enum";
import { LoanDetails, Loans } from "@/modules/loan/components";
import { getLoanTabItems } from "@/modules/loan/helpers";
import { PageHeader, ScrollableTab } from "@/shared/components";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { setActiveLoanId } from "@/shared/state/common";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const LoansPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const activeItem = useAppSelector(state => state.common);

  const [selectedTab, setSelectedTab] = useState<string>(activeItem?.loanActiveTab || LoanType.Standard);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const closeLoanDetails = () => {
    setIsOpen(false);
    dispatch(setActiveLoanId(null));
  };

  useEffect(() => {
    if (activeItem?.loanId) {
      setIsOpen(true);
    }
  }, [activeItem]);

  return (
    <>
      <div className="full-width page-container">
        <PageHeader/>
        <div className="full-width flexbox justify-content--center h-fit-content page-body">
          <div className="widget-wrapper">
            <div className="full-width mb-20">
              <Heading className="content-title" size="xsmall" weight="bolder">
                {t("loans.title")}
              </Heading>
            </div>
            <ScrollableTab
              activeTab={activeItem.loanActiveTab}
              tabEnum={LoanType}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              getTabItems={getLoanTabItems}
            />
            <Loans
              loanType={selectedTab}
              loanId={`${activeItem?.loanId}`}
              limit={1000}
            />
          </div>
        </div>
      </div>
      {isOpen && (
        <LoanDetails
          loanId={`${activeItem?.loanId}`}
          isOpen={isOpen}
          onClose={closeLoanDetails}
        />
      )}
    </>
  );
};
